




















import Vue, {PropType} from 'vue';

import DataOutput from './DataOutput.vue';
import {Timer} from '@/emulator/EmulatorInfo';

export default Vue.extend({
    props: {
        timer: {
            type: Object as PropType<Timer>,
            required: true,
        },
    },
    components: { DataOutput },
});
